import { Truck, ShoppingBag, Utensils } from 'lucide-react';
import { cn } from '@/shared/lib/utils';
import type { OrderTypeEnum } from '../types';

const LABEL: Record<OrderTypeEnum, string> = {
  DELIVERY: 'Delivery',
  PICKUP: 'Pickup',
  DINE_IN: 'Dine-in',
};

interface Props {
  type: OrderTypeEnum | undefined;
  className?: string;
  size?: 'sm' | 'md';
}

export function OrderTypePill({ type, className, size = 'sm' }: Props) {
  const Icon = type === 'DELIVERY' ? Truck : type === 'DINE_IN' ? Utensils : ShoppingBag;
  const label = type ? LABEL[type] : '—';
  const iconSize = size === 'md' ? 'w-3.5 h-3.5' : 'w-3 h-3';

  // Pickup gets a filled amber chip so owners can spot it at a glance across
  // the list. Other types stay as inline muted text — they're visually quieter
  // but still carry their own icon.
  if (type === 'PICKUP') {
    return (
      <span
        className={cn(
          'inline-flex items-center gap-1 rounded-full border border-amber-500/30 bg-amber-500/15 px-2 py-0.5 text-xs font-semibold text-amber-800 dark:text-amber-300',
          className
        )}
      >
        <Icon className={iconSize} aria-hidden />
        {label}
      </span>
    );
  }

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 text-xs text-muted-foreground font-medium',
        className
      )}
    >
      <Icon className={iconSize} aria-hidden />
      {label}
    </span>
  );
}
